import {lazyRegister} from "@/Core";
import {DistributorFilterItem, DistributorManagementFilter, DistributorManagementItem} from "@/models";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DistributorManagementService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public listByFilter(query: DistributorManagementFilter, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<DistributorManagementItem[]>('/v2/api/distributor-management', query, cancelToken);
    };

    public getByCode(code: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<DistributorFilterItem>('/api/distributor/' + code, null,
            cancelToken, {silent: true});
    };
}

lazyRegister.service('DistributorManagementService', DistributorManagementService);
